'use client';

import React from 'react';
import { UseFormRegister, FieldValues, Path } from 'react-hook-form';
import { cn } from '@/lib/utils';

interface FormTextareaProps<T extends FieldValues>
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  register?: UseFormRegister<T>;
  name: Path<T>;
}

export function FormTextarea<T extends FieldValues>({
  label,
  error,
  register,
  name,
  className,
  ...props
}: FormTextareaProps<T>) {
  return (
    <div className={cn('w-full', className)}>
      {/* ✅ Label */}
      {label && (
        <label
          htmlFor={name}
          className="mb-2 block text-sm font-medium text-gray-700"
        >
          {label}
        </label>
      )}

      {/* ✅ Textarea */}
      <textarea
        id={name}
        {...(register && register(name))}
        className={cn(
          'block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm',
          error && 'border-red-500 focus:border-red-500 focus:ring-red-500'
        )}
        {...props}
      />

      {/* ✅ Error Message */}
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
}
